var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbletTiangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "82px",
    viewBox: "0 0 26 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5578B536-B16B-4C46-978C-9F1D18D1C4BB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-3.55271368e-15 0 12.1349588 0 12.1349588 11.9285301 -3.55271368e-15 11.9285301"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 -7.10542736e-15 15.1536442 -7.10542736e-15 15.1536442 15.7692446 0 15.7692446"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Form-press",
    transform: "translate(-257.000000, -1545.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(257.093408, 1545.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(5.625071, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(7.530563, 15.437741)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48015875,7.4945301 C3.35015875,9.4305301 5.67015875,10.3095301 7.65215875,9.4545301 C8.61715875,9.0375301 9.35515875,8.2785301 9.72915875,7.3155301 C10.0941588,6.3775301 10.0671588,5.3535301 9.65515875,4.4345301 C8.78515875,2.4985301 6.46515875,1.6195301 4.48315875,2.4745301 C3.51715875,2.8915301 2.78015875,3.6505301 2.40515875,4.6125301 C2.04115875,5.5515301 2.06715875,6.5745301 2.48015875,7.4945301 M6.07915875,11.9285301 C3.74815875,11.9285301 1.52015875,10.6005301 0.520158751,8.3755301 L0.520158751,8.3745301 C-0.130841249,6.9255301 -0.171841249,5.3135301 0.403158751,3.8345301 C0.987158751,2.3315301 2.13315875,1.1475301 3.63115875,0.501530103 C6.68815875,-0.816469897 10.2671588,0.553530103 11.6151588,3.5535301 C12.2661588,5.0025301 12.3071588,6.6155301 11.7321588,8.0945301 C11.1481588,9.5975301 10.0011588,10.7815301 8.50315875,11.4275301 C7.71515875,11.7675301 6.89015875,11.9285301 6.07915875,11.9285301",
    id: "Fill-1",
    fill: "#3669C9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.42392163,6.8625709 C-0.68607837,4.3905709 0.45892163,1.5035709 2.98092163,0.415570904 C5.50292163,-0.672429096 8.44792163,0.449570904 9.55792163,2.9215709 C10.6689216,5.3945709 9.52392163,8.2805709 7.00092163,9.3685709 C4.47892163,10.4565709 1.53392163,9.3345709 0.42392163,6.8625709",
    id: "Fill-4",
    fill: "#3669C9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(9.483415, 72.268149) rotate(76.000000) translate(-9.483415, -72.268149) translate(1.906592, 64.383526)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3717,8.63734464 L12.9887,13.0353446 C13.0167,10.9223446 13.0287,7.01834464 12.8477,2.92134464 L3.3717,8.63734464 Z M14.0327,15.7693446 C13.8807,15.7693446 13.7287,15.7373446 13.5867,15.6713446 L0.6277,9.74534464 C0.2657,9.57934464 0.0247,9.22734464 0.0017,8.82934464 C-0.0213,8.43134464 0.1787,8.05434464 0.5197,7.84834464 L13.2747,0.154344643 C13.5967,-0.0396553573 13.9977,-0.0516553573 14.3297,0.123344643 C14.6627,0.299344643 14.8797,0.636344643 14.9017,1.01134464 C15.2977,7.78834464 15.1087,14.6563446 15.1077,14.7253446 C15.0977,15.0853446 14.9067,15.4163446 14.6007,15.6073446 C14.4277,15.7143446 14.2307,15.7693446 14.0327,15.7693446 L14.0327,15.7693446 Z",
    id: "Fill-6",
    fill: "#3669C9",
    mask: "url(#mask-4)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbletTiangle);
export default __webpack_public_path__ + "static/media/bubbletTiangle.2755b4bec8bbeb0ea8bd27521fadddba.svg";
export { ForwardRef as ReactComponent };